import { useEffect, useState } from 'react';
import { FiMenu, FiMoon, FiSun } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { VscCircleLargeFilled } from 'react-icons/vsc';

const NavBar = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [theme, setTheme] = useState('light');
	const navigate = useNavigate();

	const handleClick = () => {
		setIsOpen(!isOpen);
	};

	useEffect(() => {
		const stored = localStorage.getItem('theme');
		if (stored === 'dark' || stored === 'light') {
			setTheme(stored);
			document.documentElement.classList.toggle('dark', stored === 'dark');
		} else {
			const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
			const initial = prefersDark ? 'dark' : 'light';
			setTheme(initial);
			document.documentElement.classList.toggle('dark', initial === 'dark');
		}
	}, []);

	const toggleTheme = () => {
		const next = theme === 'dark' ? 'light' : 'dark';
		setTheme(next);
		localStorage.setItem('theme', next);
		document.documentElement.classList.toggle('dark', next === 'dark');
	};

	const scrollToSection = (sectionId) => {
		const element = document.getElementById(sectionId);
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
			setIsOpen(false);
		}
	};

	return (
		<nav className='fixed top-0 z-50 w-full md:w-1/2 p-2'>
			<div className='flex items-center gap-4'>
				<button
					type='button'
					onClick={toggleTheme}
					className='mr-auto inline-flex items-center gap-2 rounded-md border border-slate-200 dark:border-border px-3 py-2 text-sm font-medium bg-white text-slate-900 dark:bg-surface dark:text-textPrimary hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors'
					aria-label='Toggle theme'
				>
					{theme === 'dark' ? <FiSun /> : <FiMoon />} {theme === 'dark' ? 'Light' : 'Dark'}
				</button>
				<a
					href='/resume.pdf'
					className='hidden md:block text-xl font-bold cursor-pointer hover:text-textSecondary'
					target='_blank'
					rel='noreferrer'
				>
					Resume
				</a>
				<a
					href='/resume.pdf'
					className='text-xl font-bold cursor-pointer hover:text-textSecondary md:hidden'
					target='_blank'
					rel='noreferrer'
				>
					Resume
				</a>

				<VscCircleLargeFilled />
				<h1
					className='hidden md:block text-xl font-bold cursor-pointer hover:text-textSecondary'
					onClick={handleClick}
					onKeyDown={handleClick}
				>
					Menu
				</h1>

				<FiMenu
					className='block md:hidden text-5xl cursor-pointer'
					onClick={handleClick}
					onKeyDown={handleClick}
				/>
				{isOpen && (
					<div className='absolute top-full right-0 mt-2 bg-white dark:bg-surface border border-slate-200 dark:border-border rounded-md shadow-lg'>
						<ul className='py-1'>
							<li
								className='px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer'
								onClick={() => navigate('/')}
								onKeyDown={() => navigate('/')}
							>
								Home
							</li>
							<li
								className='px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer'
								onClick={() => scrollToSection('about')}
								onKeyDown={() => scrollToSection('about')}
							>
								About me
							</li>
							<li
								className='px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer'
								onClick={() => scrollToSection('projects')}
								onKeyDown={() => scrollToSection('projects')}
							>
								Projects
							</li>
							<li
								className='px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer'
								onClick={() => scrollToSection('socials')}
								onKeyDown={() => scrollToSection('socials')}
							>
								Socials
							</li>
						</ul>
					</div>
				)}
			</div>
		</nav>
	);
};

export default NavBar;
